import * as angular from 'angular';

import './reports/reports.component';

import './subscriptions/subscriptions.component';
import './subscriptions/subscriptionDetail.component';

var templateUrl = require('./epx.html');

angular.module('ciApp').component('epx', {
  templateUrl: templateUrl,
  controller: function() {}
});



// WEBPACK FOOTER //
// ./app/epx/epx.component.ts